import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-plus-icon",
  "use": "icon-common-plus-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-common-plus-icon\">\n  <path d=\"M8 5.50391V10.5039M10.5 8.00391H5.5M14 8.00391C14 4.69141 11.3125 2.00391 8 2.00391C4.6875 2.00391 2 4.69141 2 8.00391C2 11.3164 4.6875 14.0039 8 14.0039C11.3125 14.0039 14 11.3164 14 8.00391Z\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol